import { debounce } from "utils";

const MOBILE_BREAKPOINT = 1070;

export default function deviceTracker(config = {}, mobileBreakpoint = MOBILE_BREAKPOINT) {

  let { onMobile, onDesktop, runOnInitialization = true } = config;
  let desktopCallback = typeof onDesktop === "function" ? onDesktop : null;
  let mobileCallback = typeof onMobile === "function" ? onMobile : null;

  let desktopCleanup;
  let mobileCleanup;

  let prevDevice = getDecive(mobileBreakpoint);

  function execute(initial = false) {
    const currentDevice = getDecive(mobileBreakpoint);

    if (currentDevice !== prevDevice || initial === true) {
      prevDevice = currentDevice;

      if (currentDevice === "desktop") {
        mobileCleanup?.();
        desktopCleanup = desktopCallback?.();
      }

      else if (currentDevice === "mobile") {
        desktopCleanup?.();
        mobileCleanup = mobileCallback?.();
      }
    }
  }

  window.addEventListener("resize", debounce(execute, 450));
  execute(runOnInitialization);
}


// ---- Helpers ----------------

function getDecive(mobileBreakpoint) {
  // Check only for screen size since it is the only variable that matters for the layout and code execution.
  return window.innerWidth > mobileBreakpoint ? "desktop" : "mobile";
}